import { gql } from "@apollo/client";

export const USER_INFO = gql`
  query {
    me {
      id
      name
      email
      is_active
      phone
      organization
      country
      province
      city
      postal_code
      fax
      profile_photo_link
      address
      is_verified
      bca_va
      cashback
    }
    domain {
      domains {
        total_data
      }
    }
  }
`;

export const PROVINCES_DATA = gql`
  query {
    user {
      provinces(country_id: 1) {
        id
        name
        cities {
          id
          name
        }
      }
    }
  }
`;

export const BANNERS = gql`
  query {
    banner {
      banners {
        id
        image_link
        is_active
        index
        redirect_link
        title
        description
      }
    }
  }
`;
export const CHECK_PASSWORD = gql`
  query {
    user {
      user_check_password
    }
  }
`;
export const USER_LOGIN = gql`
  mutation (
    $email: String!
    $password: String!
  ) {
    login {
      token(
        email: $email
        password: $password
      ) {
        type
        token
        message
      }
    }
  }
`;
export const REGISTER_LOGIN = gql`
  mutation ($input: NewUser!) {
    login {
      register(input: $input) {
        type
        token
      }
    }
  }
`;
export const CHECK_REQUEST_RESET = gql`
  mutation ($token: String!) {
    user {
      user {
        check_forgot_password_token(token: $token)
      }
    }
  }
`;
export const USER_CHANGE_PASSWORD = gql`
  mutation ($input: UserChangePasswordInput!) {
    user {
      user {
        changePassword(input: $input)
      }
    }
  }
`;
export const USER_CHANGE_FORGOT_PASSWORD = gql`
  mutation ($password: String!, $confirm_password: String!, $token: String!) {
    user {
      user {
        change_forgot_password(
          password: $password
          confirm_password: $confirm_password
          token: $token
        )
      }
    }
  }
`;
export const REQUEST_RESET_PASSWORD = gql`
  mutation ($email: String!) {
    user {
      user {
        send_forgot_password(email: $email)
      }
    }
  }
`;
export const CREATE_TEMPORARY_RESELLER = gql`
  mutation ($input: NewCloudbankTemporaryReseller!) {
    temporary_reseller {
      create(input: $input) {
        id
        name
        email
        phone
      }
    }
  }
`;

export const CREATE_TEMPORARY_AFFILIATION = gql`
  mutation ($input: NewCloudbankTemporaryAffiliation!) {
    temporary_affiliation {
      create(input: $input) {
        id
        name
        email
        phone
      }
    }
  }
`;

export const USER_CHANGE_DATA = gql`
  mutation ($input: EditUser!) {
    user {
      user {
        edit_user(input: $input)
      }
    }
  }
`;

export const RESEND_EMAIL_VERIFICATION = gql`
  mutation {
    user {
      user {
        resend_verification
      }
    }
  }
`;

export const EMAIL_VERIFICATION = gql`
  mutation ($token: String!) {
    user {
      user {
        verification(token: $token)
      }
    }
  }
`;

export const LOGIN_VERIFICATION = gql`
  mutation ($token: String!) {
    login {
      login_confirmation(token: $token)
    }
  }
`;

export const RESEND_LOGIN_VERIFICATION = gql`
  mutation {
    login {
      resend_login_confirmation_user
    }
  }
`;
